import { type ComponentProps, forwardRef } from 'react'

import { TertiaryButton } from '@enechain/ecloud-designsystem'

type Props = Omit<
  ComponentProps<typeof TertiaryButton>,
  'size' | 'width' | 'minWidth' | 'padding' | 'paddingX'
> & {
  /** アイコンだけで名前が見えないので必須。 */
  'aria-label': string
}

/**
 * アイコンだけのボタン。 32px の正方形の Tertiary (白い地・枠・角丸は文字の `TertiaryButton` と同じ) にする
 * (UI 辞書 components/table.md「右端固定操作列のアイコンのみボタン」・dictionary/components.md `.btn-square`)。
 *
 * DS `IconButton` の `outline` は地が透明で、 表の縞・行の hover の色がボタンに透けるため使わない。
 * `disabled` は DS のラベル付きボタンと同じく `aria-disabled` で表され、 押せない間も focus を受ける。
 * DS `Tooltip` の trigger に置けるよう ref を通す。
 */
export const SquareIconButton = forwardRef<HTMLButtonElement, Props>(
  function SquareIconButton(props, ref) {
    return (
      <TertiaryButton
        ref={ref}
        {...props}
        width="32px"
        minWidth="32px"
        paddingX={0}
        size="sm"
      />
    )
  },
)
